/**
 * PaymentResponse : standard paymentResponse from the backend
 * This payment response is not bound to a specific paymentProvider
 */
export class PaymentResponse {
    paymentMethod: string;
    paymentID: string;
    date: number;
    isRecurring: boolean;
    isCaptured: boolean;
    isRefused: boolean;
    isAuthorized: boolean;
    needRedirect: boolean;
    returnUrl: string;
    token: string;
    mandate: string;
    paymentStatus: string;

    constructor(object?: any) {
        this.paymentMethod = object && object.paymentMethod || null;
        this.paymentID = object && object.paymentID || null;
        this.date = object && object.date || null;
        this.isRecurring = object && object.isRecurring || null;
        this.isCaptured = object && object.isCaptured || null;
        this.isRefused = object && object.isRefused || null;
        this.isAuthorized = object && object.isAuthorized || null;
        this.needRedirect = object && object.needRedirect || null;
        this.returnUrl = object && object.returnUrl || null;
        this.token = object && object.token || null;
        this.mandate = object && object.mandate || null;
        this.paymentStatus = object && object.paymentStatus || null;
    }
}

export class SubscriptionResponse {
    paymentResponse: {
        isFullyCompleted: boolean,
        Authorised: Array<PaymentResponse>
    };
    helpedUserID: string;
    helperUserID: string;
    isHelped: boolean;

    constructor(object?: any) {
        this.helpedUserID = object && object.helpedUserID || null;
        this.helperUserID = object && object.helperUserID || null;
        this.isHelped = object && object.isHelped || null;
        this.paymentResponse = { isFullyCompleted: false, Authorised: new Array<PaymentResponse>() };
        this.paymentResponse.isFullyCompleted = object && object.paymentResponse && object.paymentResponse.isFullyCompleted || false;
        if (object && object.paymentResponse && object.paymentResponse.Authorised) {
            object.paymentResponse.Authorised.forEach(element => {
                this.paymentResponse.Authorised.push(new PaymentResponse(element));
            });
        }
    }
    /**
     * @returns {boolean} Is a 3DSecure validation mandatory
     */
    need3DSecureValidation(): boolean {
        return (this.paymentResponse.Authorised && this.paymentResponse.Authorised.find(
            element => element.needRedirect === true) !== undefined);
    }
    /**
     * @returns {string | null} return the link is existing, null otherwise
     */
    get3DSecureLink(): string | null {
        if (this.paymentResponse.Authorised.length > 0) {
            let paymentResponse = this.paymentResponse.Authorised.find(element => element.needRedirect === true);
            if (paymentResponse) {
                return paymentResponse.returnUrl;
            }
        }
        return null;
    }
    /**
     * A payment is valid and captured when the paymentStatus is 'CAPTURED' for all processed payments
     * @returns {boolean} Are all payments captured ?
     */
    isValidated(): boolean {
        return (this.paymentResponse.Authorised && this.paymentResponse.Authorised.filter(
            element => (element.paymentStatus === 'CAPTURED' || element.paymentStatus === 'CAPTURE_REQUESTED')).length === this.paymentResponse.Authorised.length);
    }
    /**
     * Return if the payment method has been tokenized
     *@returns {boolean} The payment method has been tokenized ?
     */
    isTokenized(): boolean {
        return (this.paymentResponse.isFullyCompleted);
    }
    /**
     * The subscription process finished successfuly
     * @returns {boolean} The subscription is a success ?
     */
    isSuccessful(): boolean {
        return (this.paymentResponse.isFullyCompleted);
    }
    /**
     *
     */
    isSepa(): boolean {
        return this.paymentResponse.Authorised[0].mandate != null;
    }
}
